import React from 'react';
import { compose } from 'redux';
import ContentNoSidebarTemplate from 'components/templates/ContentNoSidebar';
import HeaderContainer from 'containers/HeaderContainer';
import HomeTitleContainer from 'containers/home/HomeTitleContainer';
import HomeContentContainer from 'containers/home/HomeContentContainer';
import PageTitle from 'hoc/PageTitle';
import PageTheme from 'hoc/PageTheme';
import PageView from 'hoc/PageView';
import ProtectedRoute from 'hoc/ProtectedRoute';
import { userShowGGBranding } from 'helpers/showGGBrandingTheme';
import AnalyticsDataContainer from 'containers/AnalyticsDataContainer';

const CreateHomePage = () => (
    <ContentNoSidebarTemplate
        header={<HeaderContainer hideHamburgerMenu />}
        title={<HomeTitleContainer />}>
        <HomeContentContainer />
        <AnalyticsDataContainer />
    </ContentNoSidebarTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Dashboards Home' }),
    PageView({ page: 'Viewed Home Page' }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': userShowGGBranding } }),
    ProtectedRoute(),
)(CreateHomePage);



// WEBPACK FOOTER //
// ./src/components/pages/home/HomeIndex.js